import { useEffect } from 'react';
import LandingPage from '../LandingPage';

// Google Ads / paid-traffic landing pages live under /g/<campaign>. Each one is a
// copy of the main landing page (identical behaviour by default) served at its own
// URL so Google Analytics / Vercel Analytics can track each campaign separately.
//
// These pages must stay OUT of the organic search index (see the landing-page rule
// in CLAUDE.md). The primary, reliable mechanism is an `X-Robots-Tag: noindex, nofollow`
// response header served at the edge for /g/ (see vercel.json) — crawling is intentionally
// NOT blocked in robots.txt, because a disallow would stop crawlers from ever seeing the
// noindex directive. This wrapper additionally injects a `noindex, nofollow` meta tag while
// mounted (belt-and-suspenders for JS-rendering crawlers and client-side navigations),
// removing it on unmount so it never leaks onto other routes. A static tag in index.html is
// not an option — it would de-index the entire site.
const CampaignLandingPage = () => {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => { document.head.removeChild(meta); };
  }, []);

  return <LandingPage />;
};

export default CampaignLandingPage;
